module.exports = __webpack_public_path__ + "static/img/loading.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/loading.gif
// module id = 571
// module chunks = 0